module.exports = __webpack_public_path__ + "img/attack.1a977302.png";